module.exports = __webpack_public_path__ + "ptc_nakagawa_U2.a1045047.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_U2.jpg
// module id = hBYa
// module chunks = 0